/* eslint-disable */

import { customerService } from '@/_services'
import { EventBus } from '@/event-bus.js'
import api from '@/_api'

const state = {
  items: [],
  count: 0,
  item: {},
  unassigned: [],
  notes: [],
  isLoading: false,
  itemLoading: false,
  detailsLoading: false,
  notesLoading: false,
  likes: [],

  customerRequiredFields: [],
  customerFieldDisplayNames: {},
}

const actions = {
  createCustomer({ actions }, payload) {
    return customerService.createCustomer(payload)
  },
  assignCustomerToStylist({ commit }, payload) {
    const [customer, stylist] = payload
    // Todo: Verify this endpoint
    customerService.patchCustomer({ pk: customer.pk, assigned_to: stylist.id }).then((response) => {
      if (response === undefined) {
        commit('unassign', customer)
      }
    }).catch((error) => {
      console.log('ERR', error)
      commit('unassign', customer)
    })
    commit('assign', customer)
  },
  fetchAll({ commit }, args = null) {
    commit('setIsLoading', true)
    customerService.getCustomers(args).then((response) => {
      commit('setIsLoading', false)
      commit('updateCustomers', response.data.results)
      commit('updateCount', response.data.count)
    })
  },
  fetchItem({ commit }, { id, scope, includeSpend }) {
    commit('reset')
    commit('setItemLoading', true)
    customerService.getCustomer(id, {scope, includeSpend}).then((response) => {
      commit('updateCustomer', response.data)
    }).finally(() => {
      commit('setItemLoading', false)
    })
  },
  fetchCustomerRequiredFields({ commit }) {
    // see: in CustomerViewSet's required_customer_fields() <stylelab-backend>/api/views.py:940
    customerService.getCustomerRequiredFields().then((response) => {
      commit('setCustomerRequiredFields', response.data.required_customer_fields || []);
      commit('setCustomerFieldDisplayNames', response.data.customer_field_display_names || {});
    })
  },
  patchCustomerName({ commit }, data) {
    // commit('setItemLoading', true)
    customerService.patchCustomer(data).then((response) => {
      commit('updateCustomerName', response.data)
    }).finally(() => {
      // commit('setItemLoading', false)
    })
  },
  patchCustomerImage({ commit }, { id, image }) {
    const formData = new FormData();
    formData.append('image', image);

    return api.patch(`/customer/${id}/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }).then((response) => {
      commit('updateCustomerAvatar', response.data);
    });
  },
  updateCustomerImage({ commit }, response) {
    commit('updateCustomerImage', response.data)
  },
  patchCustomerInfo({ commit }, data) {
    commit('setDetailsLoading', true)
    return customerService.patchCustomer(data).then((response) => {
      commit('updateCustomerInfo', response.data)
      EventBus.$emit('statusSuccess', response.status);
    }).catch((e) => {
      console.error(e)
      if (e.response && e.response.data) {
        EventBus.$emit('toast-error', e.response.data[0]);
      }
      else {
        EventBus.$emit('toast-error', 'Failed to update client information, please try again later.');
      }
    }).finally(() => {
      commit('setDetailsLoading', false)
    })
  },
  deleteCustomer({ dispatch }, params) {
    return customerService.deleteCustomer(params).then(() => {
      dispatch('fetchAll')
    })
  },
  //TODO: Test here
  fetchForStylist({ commit }, stylistid) {
    customerService.getCustomerForStylist(stylistid).then((response) => {
      commit('updateCustomers', response.data.results)
    })
  },
  fetchUnassigned({ commit }, q) {
    customerService.getCustomerUnassigned(q).then((response) => {
      commit('updateUnassigned', response.data.results)
    })
  },
  fetchGroup({ commit }, id) {
    commit('reset')
    customerService.getGroup(id).then((response) => {
      commit('updateGroup', response.data)
    })
  },
  fetchGroups({ commit }) {
    customerService.getGroups().then((response) => {
      commit('updateGroups', response.data.results)
    })
  },
  addGroup({ commit }, item) {
    return customerService.createGroup(item);
  },
  // eslint-disable-next-line
  patchGroup({ }, item) {
    customerService.patchGroup(item).then((r) => {
      console.log(r);
    })
  },
  deleteGroup({ dispatch }, id) {
    customerService.deleteGroup(id).then(() => {
      dispatch('fetchGroups')
    })
  },
  deleteGroupMember({ dispatch }, data) {
    customerService.deleteGroupMember(data).then((response) => {
      dispatch('fetchItem', { id: data.customer, scope: 'stylist' });
    }).catch((error) => {
      EventBus.$emit('toast-error', 'Failed to remove customer from group, try again later');
    })
  },
  fetchNotes({ commit }, id) {
    commit('setNotesLoading', true)
    customerService.fetchNotes(id).then((response) => {
      commit('saveNotes', response.data.results)
    }).finally(() => {
      commit('setNotesLoading', false)
    })
  },
  addNote({ dispatch, state }, payload) {
    customerService.addNote(payload).then(() => {
      // Refresh notes
      dispatch('fetchNotes', state.item.pk)
    })
  },
  deleteNote({ dispatch, state }, id) {
    customerService.deleteNote(state.item.pk, id).then(() => {
      dispatch('fetchNotes', state.item.pk)
    })
  },
  addPage({ commit }, args = null) {
    commit('setIsLoading', true);
    return customerService.getCustomers(args).then((response) => {
      commit('addItemPage', response.data.results)
      commit('updateCount', response.data.count)
      commit('setIsLoading', false)
      return response
    })
  },
  changeSubscription({ commit }, payload) {
    commit('setIsLoading', true);
    return customerService.changeSubscription(payload).then((response) => {
      commit('changeSubscription')
    }).catch(() => {
      EventBus.$emit('toast-error', 'Couldn\'t change subscription status, please try again later.')
    }).finally(() => {
      commit('setIsLoading', false);
    })
  },
  retrieveCustomerLikes({commit}, customerId) {
    commit('setIsLoading', true);
    return customerService.getLikes(customerId).then((response) => {
      commit('updateLikes', response.data);
    }).catch(() => {
      EventBus.$emit('toast-error', 'An unexpected error happened. Try again later.')
    }).finally(() => {
      commit('setIsLoading', false);
    });
  },
  customReset({ commit }) {
    commit('customReset', state)
  },
  reset({ commit }) {
    commit('reset')
    // console.log('committing reset!')
  },
};

const mutations = {
  // A no-op mutation must be added to serve as a trigger for a reset.
  reset(state) {
    state.items = []
    state.count = 0
    state.item = {}
    state.unassigned = []
    state.notes = []
    state.isLoading = false
    state.itemLoading = false
    state.detailsLoading = false
    state.notesLoading = false
  },
  customReset(state) {
    state.items = []
    state.count = 0
    state.item = {}
    state.unassigned = []
    state.notes = []
    state.isLoading = false
    state.itemLoading = false
    state.detailsLoading = false
    state.notesLoading = false
  },
  updateCustomerImage(state, item) {
    state.item.image = item.image;
    state.item.profile_pic = item.profile_pic;
  },
  updateCustomer(state, item) {
    state.item = item;
  },
  updateCustomerAvatar(state, item) {
    if (state.item.pk === item.pk) {
      state.item.image = item.image;
    }
  },
  updateCustomerName(state, item) {
    // Did it like this because I didn't know if modifying the hook above would have unwanted consequences.
    state.item.first_name = item.first_name;
    state.item.last_name = item.last_name;
  },
  updateCustomerInfo(state, item) {
    state.item.birth_date = item.birth_date;
    state.item.phone_number = item.phone_number;
    state.item.location = item.location;
    state.item.assigned_to = item.assigned_to;
  },
  updateUnassigned(state, items) {
    state.unassigned = items
  },
  updateCustomers(state, items) {
    state.items = items
  },
  addItemPage(state, items) {
		const pkArr = state.items.map(item => item.pk);
		const filteredItems = items.filter(item => !pkArr.includes(item.pk))
    state.items.push(...filteredItems)
  },
  updateCount(state, count) {
    state.count = count
  },
  assign(state, item) {
    const i = state.unassigned.map((item) => item.pk).indexOf(item.pk)
    state.unassigned.splice(i, 1)
    state.items.unshift(item)
  },
  unassign(state, item) {
    const i = state.items.map((item) => item.pk).indexOf(item.pk)
    state.items.splice(i, 1)
    state.unassigned.push(item)
  },
  saveNotes(state, notes) {
    state.notes = notes
  },
  setCustomerRequiredFields(state, fields) {
    state.customerRequiredFields = fields;
  },
  setCustomerFieldDisplayNames(state, names) {
    state.customerFieldDisplayNames = names;
  },
  setItemLoading(state, isLoading) {
    state.itemLoading = isLoading
  },
  setDetailsLoading(state, isLoading) {
    state.detailsLoading = isLoading
  },
  setNotesLoading(state, isLoading) {
    state.notesLoading = isLoading
  },
  setIsLoading(state, isLoading) {
    state.isLoading = isLoading
  },
  changeSubscription(state) {
    state.item.unsubscribed = !state.item.unsubscribed;
  },
  updateLikes(state, likes) {
    state.likes = likes;
  },
}

export const customers = {
  namespaced: true,
  state,
  actions,
  mutations,
}
